import { combineReducers } from '@reduxjs/toolkit'
import { EmailsReducer } from './emails'
import portalUsers from './portalUsers'
import { SmsReducer } from './smsMessages'

export default combineReducers({
  portalUsers: portalUsers,
  emails: EmailsReducer,
  smsMessages: SmsReducer,
})
